import React from 'react'
import { ClipboardPlus, Clock, ListChecks, Lock, MousePointerClick, Plus, PlusSquare, Shield, Siren, Stethoscope, Wifi } from 'lucide-react'

export default function () {
	const beneficios = [
		{
			icon: <PlusSquare size={40} className='text-emerald-600' />,
			title: "Socorro",
			description: "Pode ser usado em qualquer aparelho com acesso à internet."
		},
		{
			icon: <ClipboardPlus size={40} className='text-emerald-600' />,
			title: "Prontuário",
			description: "Contatos e localizador de emergência"
		},
		{
			icon: <MousePointerClick size={40} className='text-emerald-600' />,
			title: "Tecnologia & Acessibilidade",
			description: "Agilizar e dar mais assertividade aos atendimentos."
		}
	];

	return (
		<section id="beneficios" className="pb-20 pt-28 px-4 bg-gray-200">
			<div className="container mx-auto">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
						Zelar pela saúde com tecnologia
					</h2>
					<p className="text-lg text-gray-700 max-w-3xl mx-auto">
						Nosso sistema foi desenvolvido para garantir que suas informações médicas estejam sempre acessíveis para quem realmente importa.
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{beneficios.map((beneficio, index) => (
						<BeneficioCard
							key={index}
							icon={beneficio.icon}
							title={beneficio.title}
							description={beneficio.description}
						/>
					))}
				</div>
			</div>
		</section>
	)
}

function BeneficioCard({ icon, title, description }) {
	return (
		<div className="bg-white p-6 rounded-lg transition-all duration-300 shadow-md gradient-card">
			<div className="text-accent mb-4 flex justify-center">{icon}</div>
			<h3 className="text-xl font-semibold text-gray-900 mb-2 text-center">{title}</h3>
			<p className="text-gray-700 text-center">{description}</p>
		</div>
	)
}

